exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-label[data-v-591e7e02], .image-size[data-v-591e7e02] {\n  color: #111;\n  font-size: 0.875rem;\n}\nfigure img[data-v-591e7e02] {\n  padding: 0.125rem !important;\n  max-width: 100%;\n  max-height: 10rem !important;\n  width: auto;\n  height: auto;\n}", ""]);

// exports
